/**
 * Determines if content is SCORM-based
 *
 * SCORM content is identified solely by:
 * - delivery_method: "scorm"
 *
 * The type field (e.g. "course", "video") is not used for detection,
 * as the backend may assign any type to a SCORM-delivered item.
 */
export function isScormContent(content: any): boolean {
  if (!content) return false;

  return content.delivery_method === "scorm";
}
